//import appConstants from '../../../../../../../constants';
import { KEYS } from '../../../../../../../l18n/constants';
import { useL18nContext } from '../../../../../ContextProvider/L18n';
import computeClassName from '../../../../../../../utils/computeClassName';
//import handleClick from '../../../../../../../utils/handleClick';
import handleEventClick from "../../../../../../../utils/handleEventClick";
import IconFilter from "../../../../../Icon/Filter";

const constants = Object.freeze({
  CLASSNAME_BASE: 'pt-4 px-6 flex flex-row items-center justify-between font-normal text-cc-body-small text-cc-secondary-contrast'
});

const propsDefaults = Object.freeze({
  foundPartnerCount : 0,
  formToggleTitle: '',
  formToggleFn: null,
});

function getComputedResultsInLabel(count, getTranslationFor) {
  switch (count) {
    case 0:
      return getTranslationFor(KEYS.L18N_KEY_LABEL_NO_RESULTS);
    case 1:
      return getTranslationFor(KEYS.L18N_KEY_LABEL_RESULT);
    default:
      return getTranslationFor(KEYS.L18N_KEY_LABEL_RESULTS);
  }
}

export default function FormsControlBar({
  foundPartnerCount = propsDefaults.foundPartnerCount,
  formToggleTitle = propsDefaults.formToggleTitle,
  formToggleFn = propsDefaults.formToggleFn,
  className = '',
}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { currentLocale, getTranslationFor } = useL18nContext();
  const computedResultsInLabel = getComputedResultsInLabel(foundPartnerCount, getTranslationFor);
  const formattedFoundPartnerCount = new Intl.NumberFormat(currentLocale).format(foundPartnerCount);
  const computedFormToggleFn = handleEventClick(formToggleFn);
  const computedTranslatedFiltersLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_FILTERS);

  return (
  <div className={computedClassName}>
    <span>
      {
        (foundPartnerCount > 0) &&
        <span className="mr-cc-1char">{formattedFoundPartnerCount}</span>
      }
      <span>{computedResultsInLabel}</span>
    </span>

    <a href="/"
       className="py-1 no-underline text-cc-accent inline-flex flex-row items-center"
       title={formToggleTitle}
       aria-label={formToggleTitle}
       onClick={computedFormToggleFn}>
      <span>{computedTranslatedFiltersLabel}</span>
      <IconFilter aria-hidden="true" className="ml-2"/>
    </a>
  </div>
  )
}
